<script setup lang="ts">
const props = defineProps<{
  active?: boolean
  busy?: boolean
  open?: boolean
  unread?: boolean
}>()

const { t } = useI18n()

const iconLeading = computed(() =>
  props.active
    ? 'docue:solid-cursor-02'
    : 'docue:cursor-02',
)
</script>

<template>
  <UiButton
    type="button"
    size="xs"
    variant="ghost"
    :icon-leading
    class="relative"
    :class="{ 'bg-neutral-800/[0.08] hover:bg-neutral-800/[0.08]': open }"
  >
    <span :data-working="busy || undefined">
      {{ t('docue-agent') }}
    </span>
    <span
      v-if="unread"
      aria-hidden="true"
      class="
        absolute -right-0.5 top-1/2 size-2 -translate-y-1/2 rounded-full bg-green-500
        ring-2 ring-white
      "
    />
  </UiButton>
</template>

<style scoped>
@keyframes docue-agent-shimmer {
  from {
    background-position: 100% center;
  }

  to {
    background-position: -100% center;
  }
}

[data-working='true'] {
  color: transparent;
  background-image: linear-gradient(100deg, rgb(52 64 84) 20%, rgb(208 213 221) 50%, rgb(52 64 84) 80%);
  background-size: 200% 100%;
  background-clip: text;
  animation: docue-agent-shimmer 2s linear infinite;
  -webkit-background-clip: text;
}

@media (prefers-reduced-motion: reduce) {
  [data-working='true'] {
    color: inherit;
    background-image: none;
    animation: none;
  }
}
</style>
